/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManagerInfo
 */
export interface ManagerInfo {
    /**
     * 
     * @type {string}
     * @memberof ManagerInfo
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerInfo
     */
    photo?: string;
}

/**
 * Check if a given object implements the ManagerInfo interface.
 */
export function instanceOfManagerInfo(value: object): value is ManagerInfo {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ManagerInfoFromJSON(json: any): ManagerInfo {
    return ManagerInfoFromJSONTyped(json, false);
}

export function ManagerInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'],
        'photo': json['photo'] == null ? undefined : json['photo'],
    };
}

export function ManagerInfoToJSON(value?: ManagerInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
        'email': value['email'],
        'photo': value['photo'],
    };
}

